
export enum UserQueryType {
	TEXT = 'text',
	SELECT = 'select',
	CUSTOM = 'custom',
	DATE = 'date'
}

